import tdcpMainSiteApi from "../axios/tdcpMainSiteInstance"

export const fetchAllMainSiteContent = async (filters = {}) => {
  const url = filters?.type
    ? `/api/content/all?type=${filters.type}`
    : `/api/content/all`

  const response = await tdcpMainSiteApi.get(url)
  return response.data || []
}

export const updateMainSiteContent = async (id, data) => {
  const url = `/api/content/update/${id}`

  const response = await tdcpMainSiteApi.put(url, data)
  return response.data || []
}

export const createMainSiteContent = async (data) => {
  const url = `/api/content/create`

  const response = await tdcpMainSiteApi.post(url, data)
  return response.data || []
}

export const deleteMainSiteContent = async (id) => {
  const url = `/api/content/delete/${id}`

  const response = await tdcpMainSiteApi.delete(url)
  return response.data || []
}

export const fetchSiteNamesList = async () => {
  const url = `/api/content/names-list`

  const response = await tdcpMainSiteApi.get(url)
  return response.data || []
}

export const patchMainSiteContentStatus = async (id) => {
  const url = `/api/content/toggle-status/${id}`

  const response = await tdcpMainSiteApi.patch(url)
  return response.data || []
}